import { useEffect, useState } from 'react';
import { Loader2, Plus } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import Table, { createColumnHelper } from '../../Common/components/Table';
import useTemplates from './hooks/useTemplates';
import { Button } from '@/src/shadComponents/ui/button';
import PageShell from '@/src/Common/components/PageShell';

interface TemplateObject {
    id: number;
    name: string;
    body: string;
    assetUri: string;
    createdBy: string;
}

const columnHelper = createColumnHelper<GalleryObject>();

export default function Templates() {
    const [isLoading, setIsLoading] = useState(true);
    const [templates, setTemplates] = useState<TemplateObject[]>([]);
    const { getTemplates } = useTemplates();

    const columnDefinitions = [
        columnHelper.accessor('name', {
            id: 'name',
            header: () => <span>Name</span>,
            cell: (info) => <span>{info.getValue()}</span>,
        }),
    ];

    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            try {
                const templates = await getTemplates();
                setTemplates(templates);
            } catch (error) {
                console.error(error);
            } finally {
                isMounted && setIsLoading(false);
            }
        };

        getData();

        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) {
        return (
            <div className="flex items-center justify-center py-12">
                <Loader2 className="size-6 animate-spin text-muted-foreground" />
            </div>
        );
    }

    return (
        <PageShell
            title="Email Templates"
            breadcrumbs={[{ label: 'Email Templates' }]}
            actions={
                <NavLink to="import">
                    <Button>
                        <Plus className="size-4" />
                        Import Template
                    </Button>
                </NavLink>
            }
        >
            <Table data={templates} columns={columnDefinitions} />
        </PageShell>
    );
}
